module.exports = __webpack_public_path__ + "static/media/bedtime-buddy.cd41e286.jpg";